import React from 'react';
import Button from '../basics/Button';
import '../css/components/BotonContinuar.css';

class BotonContinuar extends Button {
	render() {
		return (
			<div className="boton-continuar__div-centrado">
				<Button className="boton-continuar__button"
					onClick={this.props.onClick} disabled={this.props.disabled}
					color="primary">{this.props.children}</Button>
			</div>
		);
	}
}

export default BotonContinuar;



// WEBPACK FOOTER //
// ./src/components/BotonContinuar.js